export const DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const PRINT_DATE_FORMAT = 'YYYY/MM/DD HH:mm:ss';
